export class Grupo{
    idgrupo: string;
    number: string;
    miembros: string | Miembro[] = []
}

export class Miembro {
    protocolo: string;
    exten: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./common/grupo.ts